import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

import { Vehicle } from '@commons/models/domain/Vehicle';
@Component({
  selector: 'app-vehicle-business-number-pin',
  standalone: true,
  imports: [TranslateModule, ButtonModule],
  templateUrl: './vehicle-business-number-pin.component.html',
  styleUrls: ['./vehicle-business-number-pin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VehicleBusinessNumberPinComponent {
  @Input() public vehicle: Vehicle;
  @Input() public title: string;
  
  public copyText(text: string): void {
    navigator.clipboard.writeText(text);
  }

  public copyAll(): void {
    navigator.clipboard.writeText(`${ this.vehicle.Nm } \nDane: \nNumer biznesowy: ${ this.vehicle.BN } \nPIN: ${ this.vehicle.DP } \n\nDane z systemu MyCar`);
  }

}
